import React from 'react';
/* eslint-disable */
export function Mobile(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.8125 2.75H6.6875C5.70312 2.75 4.9375 3.54297 4.9375 4.5V15C4.9375 15.9844 5.70312 16.75 6.6875 16.75H12.8125C13.7695 16.75 14.5625 15.9844 14.5625 15V4.5C14.5625 3.54297 13.7695 2.75 12.8125 2.75ZM9.75 15.875C9.25781 15.875 8.875 15.4922 8.875 15C8.875 14.5352 9.25781 14.125 9.75 14.125C10.2148 14.125 10.625 14.5352 10.625 15C10.625 15.4922 10.2148 15.875 9.75 15.875ZM12.8125 4.5V13.25H6.6875V4.5H12.8125Z"
        fill="currentColor"
      />
    </svg>
  );
}
